import { Star } from "lucide-react";

/**
 * Small ⭐ Professional / ⭐ Elite indicator used next to premium nav
 * items in Presentation Mode (Showcase Edition) only. Uses dedicated
 * design tokens (--presentation for Professional, --elite for Elite) —
 * never raw colors — per the premium-tier visual language.
 */
export const PremiumBadge = ({ tier }) => {
  if (!tier) return null;
  const isElite = tier === "elite";
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-wide shrink-0 ${
        isElite
          ? "bg-[hsl(var(--elite-soft))] text-[hsl(var(--elite))]"
          : "bg-[hsl(var(--presentation-soft))] text-[hsl(var(--presentation))]"
      }`}
      data-testid={`premium-badge-${tier}`}
      title={isElite ? "Elite package feature" : "Professional package feature"}
    >
      <span className="inline-flex items-center -space-x-0.5">
        <Star className="h-2.5 w-2.5 fill-current" />
        {isElite && <Star className="h-2.5 w-2.5 fill-current" />}
      </span>
      {isElite ? "Elite" : "Pro"}
    </span>
  );
};
